import { FC } from "react";
import { MuiModal } from "../../../../components/modal/MuiModal";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MuiTypography } from "../../../../components/typography/MuiTypography";
import { programSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { CreateProgramInformationWrapper } from "../../CreateProgram.style";

interface CreateProgramInformationModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  handlePrimaryButtonClick: () => void;
}
export const CreateProgramInformationModal: FC<
  CreateProgramInformationModalProps
> = ({ handleModalClose, showModal, handlePrimaryButtonClick }) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={commonLabels.information}
      primaryButtonTitle={commonLabels.ok}
      onPrimaryButtonClick={handlePrimaryButtonClick}
    >
      <CreateProgramInformationWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          className="confirm-message"
        >
          {fetchLabel(
            programSiteCoreKeys.keyProgramDetails,
            programSiteCoreKeys.programCreatedMessage,
          )}
        </MuiTypography>
      </CreateProgramInformationWrapper>
    </MuiModal>
  );
};
